/**
 * Global dialog when admin assessment assignment fails role gating
 * (API error code ASSESSMENT_ASSIGNMENT_ROLE_DENIED).
 */

function primaryMessageFromPayload(data) {
  const { message } = data;
  if (typeof message === 'string' && message.trim()) {
    return message.trim();
  }
  if (Array.isArray(message) && message.length) {
    return message.map((m) => String(m)).join('\n');
  }
  return '';
}

/** Remove " for <email|displayName>" fragments so addresses appear only in the participant list. */
function stripDeniedIdentifiersFromMessage(message, denied) {
  let out = message;
  const labels = [];
  denied.forEach((u) => {
    if (u?.displayName && String(u.displayName).trim()) labels.push(String(u.displayName).trim());
    if (u?.email && String(u.email).trim()) labels.push(String(u.email).trim());
  });
  const unique = [...new Set(labels)];
  unique.sort((a, b) => b.length - a.length);
  unique.forEach((label) => {
    const esc = label.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    out = out.replace(new RegExp(`\\s+for\\s+${esc}(?=\\s|,|\\.)`, 'gi'), ' ');
  });
  return out
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+,/g, ',')
    .replace(/\s+\./g, '.')
    .trim();
}

const AUDIT_LOG_HINT =
  '\n\nFor more details (including required roles), check the tenant administration audit log.';

function buildRoleDeniedDialogText(data) {
  const denied = Array.isArray(data.deniedUsers) ? data.deniedUsers : [];
  let text = primaryMessageFromPayload(data);
  if (denied.length && text) {
    text = stripDeniedIdentifiersFromMessage(text, denied);
  }
  if (denied.length) {
    const lines = denied.map((u) => {
      const label = (u && (u.displayName || u.email)) || (u && u.userId) || 'Unknown';
      return `• ${label}`;
    });
    const suffix = `Affected participant(s):\n${lines.join('\n')}`;
    text = text ? `${text}\n\n${suffix}` : suffix;
  }
  if (text) {
    text += AUDIT_LOG_HINT;
  }
  return text;
}

export default {
  namespaced: true,
  state: {
    dialogVisible: false,
    dialogMessage: '',
  },
  mutations: {
    OPEN_DIALOG(state, message) {
      state.dialogVisible = true;
      state.dialogMessage = typeof message === 'string' ? message : '';
    },
    CLOSE_DIALOG(state) {
      state.dialogVisible = false;
      state.dialogMessage = '';
    },
  },
  actions: {
    /**
     * If error is role-denied assessment assignment, opens the global dialog.
     * @returns {boolean} true if handled (caller should skip generic error UI)
     */
    maybeShowFromApiError({ commit }, error) {
      const data = error?.response?.data;
      if (data?.error !== 'ASSESSMENT_ASSIGNMENT_ROLE_DENIED') {
        return false;
      }
      const text = buildRoleDeniedDialogText(data);
      if (!text) {
        return false;
      }
      commit('OPEN_DIALOG', text);
      return true;
    },
    closeDialog({ commit }) {
      commit('CLOSE_DIALOG');
    },
  },
};
